var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 h-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('b-container', {
    staticClass: "align-content-start",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', _vm._l(_vm.projectSheets, function (sheet) {
    return _c('div', {
      key: sheet.id,
      staticClass: "d-flex align-items-center my-2"
    }, [_c('span', {
      staticClass: "fill"
    }, [_vm._v(_vm._s(sheet.name))]), _vm._l(_vm.sheetActions, function (action) {
      return _c('sheet-action-button', {
        key: action.action,
        attrs: {
          "sheet": sheet,
          "action": action.action,
          "icon": action.icon,
          "tooltip-key": action.tooltipKey,
          "is-link": action.isLink
        },
        on: {
          "action-click": _vm.handleActionClick
        }
      });
    })], 2);
  }), 0), _c('b-button', {
    staticClass: "w-100 mt-3",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.popup.form.create-sheet')) + " ")]), _c('custom-modal', {
    attrs: {
      "id": "create-sheet-modal",
      "title": _vm.$t(`sheet.popup.${_vm.formData.id ? 'update' : 'create'}-title`)
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('create-sheet-modal', {
          attrs: {
            "sheet": _vm.formData
          },
          on: {
            "success": _vm.onCreateOrUpdateSuccess
          }
        })];
      },
      proxy: true
    }])
  }), _c('custom-modal', {
    attrs: {
      "id": "invite-modal",
      "title": _vm.$t('sheet.popup.share.title')
    },
    on: {
      "on-hidden": _vm.resetInvite
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('invite-form-sheet', {
          attrs: {
            "id": "invite",
            "error": _vm.error,
            "loading": _vm.inviteLoading
          },
          on: {
            "submit": _vm.onInvite,
            "cancel": _vm.closeInvite
          }
        })];
      },
      proxy: true
    }])
  }), _c('confirmation-modal', {
    attrs: {
      "id": "remove-modal",
      "title-key": "sheet.popup.delete.title"
    },
    on: {
      "on-click-yes": _vm.onRemove
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function () {
        return [_c('p', {
          staticClass: "mb-3 text-center"
        }, [_vm._v(" " + _vm._s(_vm.$t('sheet.popup.delete.message', {
          name: _vm.formData.name
        })) + " ")])];
      },
      proxy: true
    }])
  }), _c('confirmation-modal', {
    attrs: {
      "id": "update-modal",
      "title-key": "sheet.popup.update.title"
    },
    on: {
      "on-click-yes": _vm.onUpdate
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function () {
        return [_c('p', {
          staticClass: "mb-3 text-center"
        }, [_vm._v(" " + _vm._s(_vm.$t('sheet.popup.update.message', {
          name: _vm.formData.name
        })) + " ")])];
      },
      proxy: true
    }])
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }